import React from "react"
import {Link} from "gatsby";
import { Container, Row, Col, Button } from "reactstrap"
// import { ReactTypeformEmbed } from "react-typeform-embed"

import MyForm from "../ContactForm/MyForm"

import contact_chat from "../../../static/images/2/contact/contact_chat.svg"
// import contact_email from "../../../static/images/2/contact/contact_email.svg"
import contact_signup from "../../../static/images/2/contact/contact_signup.svg"

import { openPopupWidget } from 'react-calendly';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

class ContactPageComp extends React.Component {
  constructor(props) {
    super(props)
    this.openForm = this.openForm.bind(this)
  }

  openForm() {
    this.typeformEmbed.typeform.open();
    // GTM EVENT
    window.dataLayer.push({
      event: "openForm",
    })

  }

  submitTypeform() {
    window.dataLayer.push({
      event: "submitForm",
    })
  }


  componentDidMount() {

    window.addEventListener('message', (event) => {
      if(event.data.event && event.data.event.indexOf('calendly') === 0){
        window.dataLayer.push({
          event: "calendlyEvent",
          eventName: event.data.event
        })
      }
    });

  }

  render() {
    const { utm } = this.props;

    // const typeFormUrl = "https://trueup.typeform.com/to/gyfLJo9m" + utm
    const url = 'https://calendly.com/brillea/brillea-call';
    const onClick = () => openPopupWidget({ url, utm });


    return (
      <>
        <div id="contact" className="section_medium section_contact bk-purple" style={{"position":"relative", "minHeight":"calc(100vh - (54px + 74px))"}}>
        {/* <ReactTypeformEmbed
          popup
          autoOpen={false}
          url={typeFormUrl}
          hideHeaders
          hideFooter
          style={{ top: 100 }}
          ref={tf => {
            this.typeformEmbed = tf;
          }}
          onSubmit={() => this.submitTypeform()}
        /> */}
            {(this.props.landing && 
            <Link to={"/agency"} style={{"color":"#FFF"}} className={"contact_exit"}><FontAwesomeIcon icon={faTimes}/></Link>
            )}
          <Container>
            <Row>
              <Col>
                <h1 className="color_yellow mb-5 pt-3">{(this.props.title ? this.props.title  : <>Want to start <br/>growing your business?</> )}</h1>
                <h3 className="color_white mb-4">If you want to get started on brillea or <span className="color_yellow">simply want to explore whether brillea is right for you</span>, get in touch today (we don't bite!)</h3>
                {/* <h4 className="color_purple_dark">We don't bite!</h4> */}
              </Col>
            {/* </Row>
            <Row className="contactWrapper_mobile justify-content-center"> */}
              {/* {(this.props.filter?.form &&
              <Col xs={{ size: 4 }} sm={{ size: 4 }}>
                <a href="#contactForm" className="contactWrapper_icon">
                  <img className="img_h50 mb-3 mt-2" src={contact_email} alt="contact brillea via email"/>
                  <h5 className="color_yellow mb-3">Email</h5>
                </a>
              </Col>
              )}
              {(this.props.filter?.chat &&
              <Col xs={{ size: 4 }} sm={{ size: 4 }}>
                <a href="#contactChat" className="contactWrapper_icon">
                  <img className="img_h50 mb-3 mt-2" src={contact_chat} alt="contact brillea via email"/>
                  <h5 className="color_yellow mb-3">Call</h5>
                </a>
              </Col>
              )}
              {(this.props.filter?.signUp &&
              <Col xs={{ size: 4 }} sm={{ size: 4 }}>
                <a href="#contactSignup" className="contactWrapper_icon">
                  <img className="img_h50 mb-3 mt-2" src={contact_signup} alt="contact brillea via email"/>
                  <h5 className="color_yellow mb-3">Sign up</h5>
                </a>
              </Col>
              )}
            </Row>
            <Row className="justify-content-center"> */}
              {(this.props.filter?.form &&
              <Col md={{ size: 6 }}>
                <div id="contactForm" style={{paddingBottom:"4rem"}}>
                  <div className="contactWrapper">
                    {/* <div className="contactWrapper_icon hidden-sm">
                      <img className="img_h50 mb-3 mt-2" src={contact_email} alt="contact brillea via email"/>
                    </div> */}
                    {/* <h4 className="color_white">Get in touch?</h4> */}
                    {/* <h5 className="color_yellow mt-3 mb-3 hidden-sm">Send us a message</h5> */}
                    <div className="contactWrapper_content">
                      <MyForm />
                    </div>
                  </div>
                </div>
              </Col>
              )}
              {(this.props.filter?.chat &&
              <Col md={{ size: 4 }}>
                <div id="contactChat">
                  <div className="contactWrapper">
                    <div className="contactWrapper_icon hidden-sm">
                      <img className="img_h50 mb-3 mt-2" src={contact_chat} alt="contact brillea via email"/>
                    </div>
                    <h4 className="color_white">Want to chat?</h4>
                    <h5 className="color_yellow mt-3 mb-3 hidden-sm">let's get it in the diary</h5>
                    <div className="contactWrapper_content">
                      <p className="white_color">If you'd prefer to chat in real-time with our team, book in for a call.</p>

                      <Button onClick={onClick} color="secondary">Book a call</Button>
                      {/* <p className="white_color mt-2 mb-0"><small>No hard sales</small></p>                       */}
                    </div>
                  </div>
                </div>
              </Col>
              )}
              {(this.props.filter?.signUp &&
              <Col md={{ size: 4 }}>
                <div id="contactSignup">
                  <div className="contactWrapper">
                    <div className="contactWrapper_icon hidden-sm">
                      <img className="img_h50 mb-3 mt-2" src={contact_signup} alt="contact brillea via email"/>
                    </div>
                    <h4 className="color_white">Let's get started!</h4>
                    <h5 className="color_yellow mt-3 mb-3 hidden-sm">Sign me up</h5>
                    <div className="contactWrapper_content">
                      <p className="white_color">Let's start your journey to healthy marketing and growth.</p>
                      <Button onClick={this.openForm} color={"secondary"}>Sign up</Button>
                      {/* <p className="white_color mt-2 mb-0"><small>No payment details needed</small></p> */}
                    </div>
                  </div>
                </div>
              </Col>
              )}
            </Row>
          </Container>
        </div>
    </>
    )
  }
}

export default ContactPageComp
